/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { upsertPicklistOptionRequestSchema } from './upsertPicklistOptionRequestSchema';

export const updateFieldRequestSchema = z.object({
  afterId: z.int().nullish(),
  archived: z.boolean(),
  beforeId: z.int().nullish(),
  currencyUnit: z.string().nullish(),
  itemTypeAssociationMode: z.optional(z.enum(['ALL', 'CUSTOM'])),
  name: z.string(),
  get picklistOptions() {
    return z.array(upsertPicklistOptionRequestSchema).nullish();
  },
});
